"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.handleLocalhostToken = exports.handleLocalhostAction = exports.makeLocalhostRedirectUrl = exports.isLocalhostRedirect = exports.getLocalhostBaseUrl = void 0;
const redirect_1 = require("../../build-babel/redirect/redirect");
const token_1 = require("../../build-babel/token");
const session_1 = require("../../build-babel/session");
const LOCALHOST_BASE_URL = 'https://localhost:8080';
const getLocalhostBaseUrl = () => LOCALHOST_BASE_URL;
exports.getLocalhostBaseUrl = getLocalhostBaseUrl;
const isLocalhostRedirect = redirectUrl => redirectUrl === LOCALHOST_BASE_URL;
exports.isLocalhostRedirect = isLocalhostRedirect;
const makeLocalhostRedirectUrl = idToken => `${LOCALHOST_BASE_URL}/auth?token=${idToken}`;
exports.makeLocalhostRedirectUrl = makeLocalhostRedirectUrl;
const handleLocalhostAction = (action, env) => {
  // redirect from localhost to proper login \ logout page
  const urlDomain = env === 'qa' ? 'wwwtest.hapag-lloyd.com' : 'wwwdeve.hapag-lloyd.com';
  if ('login' === action) {
    (0, redirect_1.makeRedirectTo)(`https://${urlDomain}/solutions/auth/login.html?redirect_url=${encodeURIComponent(LOCALHOST_BASE_URL)}`);
  } else if ('logout' === action) {
    (0, redirect_1.makeRedirectTo)(`https://${urlDomain}/solutions/auth/logout.html?redirect_url=${encodeURIComponent(`${LOCALHOST_BASE_URL}/auth`)}`);
  }
};
exports.handleLocalhostAction = handleLocalhostAction;
const handleLocalhostToken = token => {
  if (token && (0, token_1.isJTWToken)(token)) {
    (0, session_1.setSession)(token, LOCALHOST_BASE_URL);
  } else {
    (0, session_1.removeSession)(LOCALHOST_BASE_URL);
  }
};
exports.handleLocalhostToken = handleLocalhostToken;
//# sourceMappingURL=localhost.js.map